import styled from 'styled-components/macro';
import { FieldSet } from '../../shared/form/FieldSet';
import { medium, wide } from '../../styling/spacing';

export const WorksheetFieldSet = styled(FieldSet)`
  padding-top: ${wide};
  padding-bottom: ${medium};
  margin-bottom: ${wide};
`;
